import { useState, useCallback, useEffect } from "react";
import { memoryStore, setItemImmediate } from "../utils/storage";

const NOTES_KEY = "pension_fund_notes_v1";

function loadNotes() {
  try {
    const raw = memoryStore.getItem(NOTES_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveNotes(notesObj) {
  try {
    setItemImmediate(NOTES_KEY, JSON.stringify(notesObj));
  } catch {}
}

export function getFundUniqueKey(clientId, fund) {
  if (!clientId || !fund) return null;
  const comp = fund.companyName ? fund.companyName.trim().replace(/\s+/g, "_") : "Unknown";
  const pol = fund.polNum ? fund.polNum.toString().replace(/[- ]/g, "") : (fund.misparKupa || "unknown");
  
  // Differentiate funds with the same policy number (e.g. Makifa vs Mashlima)
  let diff = (fund.kidodAchid || fund.sugMutzar || fund.sugTochnit || "").toString().trim().replace(/\s+/g, "_");
  if (!diff && fund.tochnit) {
    if (fund.tochnit.includes("מקיפה")) diff = "makifa";
    else if (fund.tochnit.includes("משלימה")) diff = "mashlima";
  }
  
  return `${clientId}_${comp}_${pol}_${diff}`;
}

export function useFundNotesStore() {
  const [notes, setNotesState] = useState(loadNotes);

  useEffect(() => {
    const handleSync = () => setNotesState(loadNotes());
    window.addEventListener("pensionSyncUpdate", handleSync);
    return () => window.removeEventListener("pensionSyncUpdate", handleSync);
  }, []);

  const setNote = useCallback((key, text) => {
    if (!key) return;
    setNotesState(prev => {
      const next = { ...prev };
      if (!text || !text.trim()) {
        delete next[key];
      } else {
        next[key] = text.trim();
      }
      saveNotes(next);
      return next;
    });
  }, []);

  const getNote = useCallback((key) => {
    if (!key) return "";
    return notes[key] || "";
  }, [notes]);

  return {
    notes,
    setNote,
    getNote,
  };
}
